/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Project Properties that are used for filtering.
 *
 */
export var PropertiesForFiltering;
(function (PropertiesForFiltering) {
    PropertiesForFiltering["TIMESTAMP"] = "timestamp";
})(PropertiesForFiltering || (PropertiesForFiltering = {}));
